// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1yRlY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3CMGj"};